<script setup lang="ts">
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { type RouteLocation, RouterLink, useRouter } from "vue-router";

import { useSearchRoute } from "@/common/composables/use-search-route";
import { useSearchStore } from "@/stores";
import type { GyldendalReference } from "@/types/article-formats/gyldendal";

const props = defineProps<{
  reference: GyldendalReference;
}>();

const router = useRouter();
const { getSearchRoute } = useSearchRoute(router);

const { searchDirection } = storeToRefs(useSearchStore());

const meaningRef = computed(() => props.reference.reference.toLowerCase());

const searchRoute = computed<RouteLocation | undefined>(() => {
  if (!searchDirection.value) {
    return undefined;
  }

  return getSearchRoute(props.reference.text, searchDirection.value);
});
</script>

<template>
  <span>
    <template v-if="reference.isLink && searchRoute">
      <RouterLink class="article-content__link" :to="searchRoute">{{ reference.text }}</RouterLink
      ><sup v-if="meaningRef">{{ meaningRef }}</sup
      ><span v-if="reference.targetDescription" class="article-content__reference-description">{{
        reference.targetDescription
      }}</span>
    </template>
    <template v-else>
      <span v-html="reference.text"></span
      ><span v-if="reference.targetDescription" class="article-content__reference-description">{{
        reference.targetDescription
      }}</span>
    </template>
    <slot></slot>
  </span>
</template>
